<template>
  <div>
    <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
      <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
      <div>
        <el-radio-group class="mr-r5" v-model="isAuthAp">
          <el-radio :label="true">인가</el-radio>
          <el-radio :label="false">비인가</el-radio>
        </el-radio-group>
        <w-header-search-button v-if="isAuthAp === true" @click="authShowSearchTool = !authShowSearchTool"/>
        <w-header-search-button v-else @click="forbidShowSearchTool = !forbidShowSearchTool"/>
      </div>
    </el-row>
    <el-row v-show="isAuthAp === true">
      <el-table-wrapper
        ref="authApTable"
        class="inner-table"
        v-loading="authLoading"
        :data="authApData"
        :columns="authColumns"
        :show-custom-header="true"
        :show-search-tool="authShowSearchTool"
        :show-overflow-tooltip="true"
        :pagination="true"
        :column-default="columnDefault"
        @expand-change="onExpandChange"
      >
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{ scope.row.objName }}</span>
          <span v-else>-</span>
        </template>
         <template v-if="operationFlag" #wireless-expand-slot="scope">
          <w-ap-client-table table-class="popup" :data="scope.row.clients" :loading="scope.row.apLoading" :show-search-tool="false" :obj-company-id="scope.row.objCompanyId" />
        </template>
      </el-table-wrapper>
    </el-row>
    <el-row v-show="isAuthAp === false">
      <el-table-wrapper
        ref="forbidApTable"
        v-loading="authLoading"
        :data="forbidApData"
        :columns="forbidColumns"
        :show-custom-header="true"
        :show-search-tool="forbidShowSearchTool"
        :show-overflow-tooltip="true"
        :column-default="columnDefault"
      >
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, cloneDeep, concat, findIndex } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { booleanDefine } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import { getApStatusName, showApSnr, showRogueApStatus, getRogueApStatus } from '@/utils/wireless-device';
import { objtype } from '@/constants/objtype';
import { columnDefault } from '@/constants/table';
import { analysisTimeType, performanceNodeTabs } from '@/constants/performance';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import controllerInfoAPI from '@/api/performance/ap-controller/controller-info';
import commonAPI from '@/api/performance/common';
import WApClientTable from '@/views/performance/components/wireless/ApClientTable';

export default {
  name: 'WWirelessApTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
    WApClientTable,
  },
  props: {
    active: {
      type: Boolean,
    },
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['selectedNode']),
    showApSnr() {
      return showApSnr(this.selectedNode.obj.objCompanyId);
    },
    showRogueApStatus() {
      return showRogueApStatus(this.selectedNode.obj.objCompanyId);
    },
  },
  data() {
    return {
      authTotal: 0,
      authLoading: false,
      tableData: [],
      authShowSearchTool: false,
      forbidShowSearchTool: false,
      checkDatetime: null,
      columnDefault,
      isAuthAp: true,
      total: null,
      authApData: [],
      forbidApData: [],
      authColumns: [],
      authOriginColumns: [
        {
          prop: 'objName',
          label: '장비명',
          scopedSlot: 'obj-name-slot',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'objMacaddress',
          label: 'MAC',
          remoteProp: 'o.obj_macaddress',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'objCompanyName',
          label: '제조사',
          remoteProp: 'oc.obj_company_name',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'ssid',
          label: 'WLAN',
          remoteProp: 'ncmInfo.ssid',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'radioBand',
          label: '주파수 대역',
          remoteProp: 'ncmInfo.radioBand',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'apGroup',
          label: 'AP 그룹',
          remoteProp: 'ncmInfo.apGroup',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'WIRELESS_ACCESSPOINT/AP_STATUS',
          label: '상태',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getApStatusName(value),
        },
        {
          prop: 'WIRELESS_ACCESSPOINT/CLIENT_COUNT',
          label: '접속자 수',
          sortable: true,
          searchable: false,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          label: '트래픽',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'WIRELESS_ACCESSPOINT/AP_TRAFFIC_BPS_IN',
              label: 'IN',
              sortable: true,
              headerAlign: 'center',
              formatter: (row, column, value) => convertValuByUnit(value, 'bps', true, true, true),
              width: 80,
            },
            {
              prop: 'WIRELESS_ACCESSPOINT/AP_TRAFFIC_BPS_OUT',
              label: 'OUT',
              sortable: true,
              headerAlign: 'center',
              formatter: (row, column, value) => convertValuByUnit(value, 'bps', true, true, true),
              width: 80,
            },
          ],
        },
      ],
      forbidColumns: [],
      forbidOriginColumns: [
        {
          prop: 'bssid',
          label: 'bssid',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'essid',
          label: 'essid',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'radioBand',
          label: '주파수 대역',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
        {
          prop: 'channel',
          label: '채널',
          sortable: true,
          searchable: true,
          formatter: (row, column, value) => getValueAfterCheckEmpty(value),
        },
      ],
    };
  },
  watch: {
    isAuthAp: {
      handler() {
        this.loadData();
      },
    },
    showApSnr: {
      immediate: true,
      handler() {
        this.addSnrColumn();
      },
    },
    showRogueApStatus: {
      immediate: true,
      handler() {
        this.addStatusColumn();
      },
    },
    operationFlag: {
      immediate: true,
      handler() {
        if (this.operationFlag) {
          this.addExpandColumn(true);
        }
      },
    },
  },
  methods: {
    /**
     * 무선 AP 정보를 조회한다.
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        managetypeId: 'NMS',
        objDefineId: 'WIRELESS_DEVICE',
      };
      this.$nextTick(() => {
        if (this.operationFlag) {
          this.addExpandColumn();
        }
        if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
          params.baselineDatetime = this.plotLineDatetime;
          params.objtypeId = objtype.WIRELESS_AP;
          // 스냅샷
          this.authLoading = true;
          controllerInfoAPI
            .getApContollerStateList(params)
            .then((response) => {
              if (response.data.success === true) {
                const snapshotData = response.data.data;
                this.authApData = isEmpty(snapshotData.snapshotDoc) ? [] : snapshotData.snapshotDoc.auth;
                this.forbidApData = isEmpty(snapshotData.snapshotDoc) ? [] : snapshotData.snapshotDoc.rogue;
                this.checkDatetime = snapshotData.timestamp;
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
            })
            .finally(() => {
              this.authLoading = false;
            });
        } else if (this.isAuthAp) {
          params.objtypeId = objtype.WIRELESS_AP;
          const searchParams = this.$refs.authApTable.getParameter();
          const targetParams = {
            ...params,
            ...searchParams,
          };
          this.authLoading = true;
          controllerInfoAPI
            .getCurrentWirelessApInfoByController(targetParams)
            .then((response) => {
              if (response.data.success === true) {
                const authApData = response.data.data;
                this.authTotal = response.data.total;
                authApData.forEach((item) => {
                  item.isExpand = false;
                  item.apLoading = false;
                  item.clients = null;
                });
                this.authApData = authApData;
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
            })
            .finally(() => {
              this.authLoading = false;
            });
        } else {
          this.column = cloneDeep(this.forbidColumns);
          this.authLoading = true;
          const searchParams = this.$refs.forbidApTable.getParameter();
          const targetParams = {
            ...params,
            ...searchParams,
          };
          controllerInfoAPI
            .getCurrentRougeApInfoByController(targetParams)
            .then((response) => {
              if (response.data.success === true) {
                const forbidApData = response.data.data;
                this.forbidApData = forbidApData;
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '무선 AP 정보', false));
            })
            .finally(() => {
              this.authLoading = false;
            });
        }
      });
    },
    /**
     * 무선 AP 명 클릭 시 성능/운영 > 요약 탭으로 이동한다.
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickApName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    // 오버라이딩
    onCurrentDataReLoad() {
      this.loadData(true);
    },
    /**
     * expandrow가 필요한 경우
     * @author yelim
     */
    addExpandColumn() {
      this.authColumns = [];
      this.$nextTick(() => {
        const columns = cloneDeep(this.authOriginColumns);
        let expandCols = concat(
          [
            {
              type: 'expand',
              scopedSlot: 'wireless-expand-slot',
            },
          ],
          columns,
        );
        if (this.showApSnr) {
          expandCols = concat(
            expandCols,
            [
              {
                prop: 'WIRELESS_ACCESSPOINT/AP_SNR',
                label: 'SNR',
                sortable: true,
                searchable: false,
                formatter: (row, column, value) => convertValuByUnit(value, 'dBm', true, true, true),
              },
            ],
          );
        }
        this.authColumns = expandCols;
      });
    },
    addSnrColumn() {
      this.authColumns = [];
      this.$nextTick(() => {
        if (this.showApSnr) {
          const columns = cloneDeep(this.authOriginColumns);
          const concatCols = concat(
            columns,
            [
              {
                prop: 'WIRELESS_ACCESSPOINT/AP_SNR',
                label: 'SNR',
                sortable: true,
                searchable: false,
                formatter: (row, column, value) => convertValuByUnit(value, 'dBm', true, true, true),
              },
            ],
          );
          this.authColumns = concatCols;
        } else {
          const columns = cloneDeep(this.authOriginColumns);
          this.authColumns = columns;
        }
      });
    },
    addStatusColumn() {
      this.forbidColumns = [];
      this.$nextTick(() => {
        if (this.showApSnr) {
          const columns = cloneDeep(this.forbidOriginColumns);
          const concatCols = concat(
            columns,
            [
              {
                prop: 'status',
                label: '상태',
                sortable: true,
                searchable: true,
                formatter: this.getConvertStatusValue,
                // formatter: (row, column, value) => getValueAfterCheckEmpty(value),
              },
            ],
          );
          this.forbidColumns = concatCols;
        } else {
          const columns = cloneDeep(this.forbidOriginColumns);
          this.forbidColumns = columns;
        }
      });
    },
    /**
     * 무선 AP 정보를 펼치면 클라이언트 정보를 조회한다.
     * @author yelim
     * @param  {[type]} rowInfo [description]
     * @return {[type]}         [description]
     */
    onExpandChange(rowInfo) {
      const findIdx = findIndex(this.authApData, (item) => item.objId === rowInfo.objId);
      // 선택한 AP의 클라이언트 정보를 조회할 때
      // 1) 이미 조회가 된 경우, row를 닫고 정보를 초기화한다.
      // 2) 조회되지 않은 경우, row를 열고 선택한 row의 objId 정보를 가지고 목록을 조회한다.
      if (!rowInfo.isExpand) {
        rowInfo.isExpand = true;
        this.authApData[findIdx].apLoading = true;
        commonAPI
          .getClientInfoByWireless({
            objId: rowInfo.objId,
          })
          .then((result) => {
            if (result.data.success) {
              const resultData = result.data.data;
              if (!isNil(resultData)) {
                this.authApData[findIdx].clients = resultData;
              }
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '클라이언트 정보', false));
            throw new Error(e);
          })
          .finally(() => {
            this.authApData[findIdx].apLoading = false;
          });
      } else {
        rowInfo.isExpand = false;
        this.authApData[findIdx].clients = [];
      }
    },
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    /**
     * 비인가 AP인 경우 치환 가능한 값은 UP/DOWN, 치환 불가한 값은 그대로 표현하도록 하는 formmater
     * @author yelim
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getConvertStatusValue(row, column, value) {
      return getRogueApStatus(value);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/ap-controller/components/table/WirelessApTable.vue